/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface CompanyModel {

        "companyName"?: string;

        "tradingName"?: string;

        "stateRegistration"?: number;

        "cityRegistration"?: number;

        "cadastur"?: number;

        "iata"?: string;

        "subIata"?: string;

        "snea"?: string;

        "homepage"?: string;

        "phones"?: Array<PhoneModel>;

        "email"?: string;

        "confirmEmail"?: string;

        "password"?: string;

        "confirmPassword"?: string;

        "cvcBranch"?: number;
    }

}
